
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class StaticResourceState extends BaseYcState {
  readonly sas: string;
}
